import { For, type JSX } from 'solid-js'
import type { FlyingStamp } from '~/lib/flying-stamps'

// Renders the fan of icons that fly from a reward toward a currency pill. The
// trajectory for each icon comes from flyingStampsFrom(); this component just
// paints them and lets the `animate-stamp-fly` CSS keyframes (driven by the
// per-icon --dx/--dy/animation-delay) carry them home. The icon source is a
// prop so the same flight works for stamps, coins, and gems.
export function FlyingIcons(props: {
  stamps: FlyingStamp[]
  icon: string
}): JSX.Element {
  return (
    <For each={props.stamps}>
      {(stamp) => (
        <img
          src={props.icon}
          alt=""
          aria-hidden="true"
          class="pointer-events-none fixed size-10 animate-stamp-fly"
          style={{
            left: `${stamp.startX}px`,
            top: `${stamp.startY}px`,
            '--dx': `${stamp.dx + stamp.offsetX}px`,
            '--dy': `${stamp.dy}px`,
            'animation-delay': `${stamp.delay}ms`,
          }}
        />
      )}
    </For>
  )
}
